import { FetchLocalStorage } from "./LocalStorage";

export const localStorageRemoveItemSafe = <Key extends keyof FetchLocalStorage>(
  key: Key,
): void => {
  localStorage.removeItem(key);
};
